import React, { createContext, useContext, useMemo } from 'react';

const MacroContext = createContext();

// Region mapping for better maintainability and performance
const REGION_MAP = {
  'PT-BR': 'TDB',
  'ES-AR': 'TASA',
  'ES-VE': 'TDV'
};

function MacroProvider({ children, locale, productId }) {
  // Extract country and language from locale
  const country = locale?.split('-')[1]?.toUpperCase(); // 'BR', 'AR', 'VE'
  const lang = locale?.split('-')[0]?.toLowerCase();   // 'pt', 'es'

  // Determine tenant based on locale using map lookup
  const getRegionFromLocale = (locale) => {
    if (!locale) { return null; }
    const upperLocale = locale.toUpperCase();
    return REGION_MAP[upperLocale] ?? null;
  };

  const regionLocale = getRegionFromLocale(locale);

  // Memoize the entire value object to prevent unnecessary re-renders
  const value = useMemo(() => ({
    country,
    lang,
    regionLocale,
    locale,
    productId,
    isTDB: regionLocale === 'TDB',
    isTasa: regionLocale === 'TASA',
    isTDV: regionLocale === 'TDV'
  }), [locale, productId]);

  return (
    <MacroContext.Provider value={value}>
      {children}
    </MacroContext.Provider>
  );
}

function useMacroContext() {
  const context = useContext(MacroContext);
  if (context === undefined) {
    throw new Error('useMacroContext must be used within a MacroProvider');
  }
  return context;
}

export { MacroProvider, MacroContext, useMacroContext };
